import { useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'

import {
  FaEnvelope,
  FaPhone,
  FaIdBadge,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaHashtag,
} from 'react-icons/fa'
import { LuGraduationCap } from 'react-icons/lu'
import { BsEyeFill, BsArrowLeft } from 'react-icons/bs'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import ApiEndpoints from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import {
  NO_STAMP_SRC,
  getInstituteStampPathFromRecord,
  resolveInstituteLogoSrc,
  resolveInstituteStampSrc,
} from '../utils/instituteBranding'
import html2canvas from 'html2canvas'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'

function blobToDataURL(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

async function fetchImageAsDataUrlForCanvas(url) {
  if (!url || url.startsWith('data:')) return url
  try {
    const res = await fetch(url, { mode: 'cors', credentials: 'omit' })
    if (res.ok) return await blobToDataURL(await res.blob())
  } catch {
    /* cross-origin without CORS */
  }
  try {
    const proxied = `https://images.weserv.nl/?url=${encodeURIComponent(url)}`
    const res = await fetch(proxied)
    if (!res.ok) throw new Error(String(res.status))
    return await blobToDataURL(await res.blob())
  } catch {
    /* try second proxy */
  }
  try {
    const res = await fetch(
      `https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`,
    )
    if (!res.ok) throw new Error(String(res.status))
    return await blobToDataURL(await res.blob())
  } catch (e) {
    console.warn('Canvas export: could not inline image', url, e)
    return url
  }
}

async function inlineImagesForHtml2Canvas(rootEl) {
  const imgs = [...rootEl.querySelectorAll('img')]
  const backups = []
  for (const img of imgs) {
    const current = img.currentSrc || img.src
    if (!current || current.startsWith('data:')) continue
    backups.push([img, current])
    try {
      const dataUrl = await fetchImageAsDataUrlForCanvas(current)
      img.src = dataUrl
      if (img.decode) await img.decode().catch(() => {})
    } catch {
      backups.pop()
    }
  }
  return () => {
    for (const [img, src] of backups) {
      img.src = src
    }
  }
}

export default function TeacherIdcard() {
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const { id } = useParams()
  const location = useLocation()
  const [teacher, setTeacher] = useState(location.state?.teacher || null)

  const navigate = useNavigate()
  const frontRef = useRef()
  const backRef = useRef()

  const downloadAsJPG = async (element, filename) => {
    const restoreImages = await inlineImagesForHtml2Canvas(element)
    try {
      const canvas = await html2canvas(element, {
        backgroundColor: '#fff',
        useCORS: true,
        allowTaint: false,
        imageTimeout: 15000,
      })
      const image = canvas.toDataURL('image/jpeg', 1.0)

      const link = document.createElement('a')
      link.href = image
      link.download = `${filename}.jpg`
      link.click()
    } finally {
      restoreImages()
    }
  }

  const handleDownloadBoth = () => {
    if (frontRef.current) downloadAsJPG(frontRef.current, 'ID_Card_Front')
    if (backRef.current) downloadAsJPG(backRef.current, 'ID_Card_Back')
  }

  const [institutes, setInstitutes] = useState('')
  const [institueLogoApi, setInstitueLogoApi] = useState('/no_image.png')
  const [stampUrlApi, setStampUrlApi] = useState(NO_STAMP_SRC)

     const [instituteCookies, setInstituteCookies] = useState(null);
  
  
     
      useEffect(() => {
        const storedInstituteName = Cookies.get("name");
        const storedAddress = Cookies.get("address");
        const storedPincode = Cookies.get("pincode");
        const storedSessionName = Cookies.get("session_name");
        console.log("Stored institute from cookies:", storedInstituteName);
        if (storedInstituteName || storedAddress) {
          setInstituteCookies({
            name: storedInstituteName,
            address: storedAddress,
          pincode: storedPincode,
          session_name: storedSessionName,
          });
        }
      }, []);
  
    console.log('institueLogoApi', institueLogoApi)

  // useEffect(() => {
  //   const storedInstitute = Cookies.get('institute_name')
  //   if (storedInstitute) {
  //     setInstitutes(storedInstitute)
  //   }
  // }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    if (!teacher && id && institueId) {
      ApiEndpoints.getAllTeachers({ 'institute-Id': Number(institueId) })
        .then((res) => {
          if (Array.isArray(res.data.data)) {
            const matchedTeacher = res.data.data.find(
              (t) => String(t.id) === String(id),
            )
            if (matchedTeacher) {
              setTeacher(matchedTeacher)
            } else {
              console.error('No teacher found with ID:', id)
            }
          }
        })
        .catch((err) => {
          console.error('Failed to fetch teachers:', err)
        })
    }
  }, [id, teacher])

  useEffect(() => {
    if (!teacher?.institute_id) {
      return
    }

    ApiEndpoints.getAllInstitutes()
      .then((res) => {
        if (Array.isArray(res.data.data)) {
          const matched = res.data.data.find(
            (inst) => inst.institute_id === teacher.institute_id,
          )

          if (matched) {
            setInstitueLogoApi(
              resolveInstituteLogoSrc(
                Cookies.get('institute_logo') || matched.institute_logo,
              ),
            )
            setInstitutes(matched)
            setStampUrlApi(
              resolveInstituteStampSrc(
                Cookies.get('institute_stamp') ||
                  Cookies.get('stamp_url_img') ||
                  getInstituteStampPathFromRecord(matched),
              ),
            )
          } else {
            setInstitutes({ institute_name: 'Unknown Institute' })
          }
        }
      })
      .catch((error) => console.error('Error fetching institutes:', error))
  }, [teacher?.institute_id])

  const handlePrint = () => {
    const printWindow = window.open('', '', 'width=1000,height=700')

    const frontCardHTML = document.querySelector('.front-card')?.outerHTML || ''
    const backCardHTML = document.querySelector('.back-card')?.outerHTML || ''
    const printBaseHref =
      typeof window !== 'undefined'
        ? new URL(process.env.PUBLIC_URL || '/', window.location.origin).href
        : ''

    printWindow.document.write(`
      <html>
        <head>
          <title>ID Card</title>
          <base href="${printBaseHref}" />

          <style>
  @page {
    // size: A5 portrait;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background: white;
  }

  .print-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: row;
    gap: 20px;
    padding: 10mm;
    box-sizing: border-box;
  }

  .page-break {
    page-break-after: always;
  }

  .card {
    width: 360px;
    height: 500px;
    // width: 86mm ;
    // height: 55mm ;
    border: .5px solid #000;
    border-radius: 15px;
    padding: 5px;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #fff;
  }

  .front-card, .back-card {
    box-shadow: none !important;
  }

  .institute-header {
    height: 67px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
    flex-direction: column !important;
  }
.inst-name{
    font-size:18px !important;
    margin-top:2px !important;
}
    .inst-about{
    font-size:15px !important;
  color: rgba(255, 255, 255, 0.6);
}
  .student-name {
    text-align: center !important;
    margin-top: .7rem !important;

  }
.student-bio {
  margin-left: 10px !important;
  color: #223843;
}

.student-bio .bio-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 8px;
  gap:2px;
  color: #223843;
}

.student-bio .bio-item svg {
  margin-bottom: 4px; /* Space between icon and text */
  color: #223843;
  font-size: 18px;
}

.student-bio .bio-item p {
  margin: 0;
  font-size: 13px;
  color: #223843;
}

  .stamp {
    display: flex !important;
    justify-content: center !important;
    margin-top: 1.8rem !important;
    // margin-bottom: -6px !important;
  }


.print-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem !important;
}

.print-image {
  width: 50px !important;
  height: 50px !important;
  border: 2px solid #223843 !important;
  background: white !important;
  object-fit: cover !important;
}

  h1, h2, h3, h4, h5, h6, p, span, strong {
    font-size: 15px !important;
    margin: 2px 0 !important;
  }

  .text-primary {
    color: #223843 !important;
  }

  .small {
    font-size: 13px !important;
  }

  .fw-bold {
    font-weight: bold;
  }

  .rounded-circle {
    border-radius: 50% !important;
  }

  // Back portion of ID Card
.inst-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // gap: 5px;
  // padding: 0 5px;
}

.inst-logo img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem !important;
  margin-bottom: 1rem !important;
  max-width:80% !important;
}

.inst-info {
  text-align: center;
  flex: 1;
  letter-spacing:2px !important;
    font-size: 19px;
  margin-top: 0rem;
}

.ins-card{
  margin-top: 2rem;
}
.inst-data {
  flex: 2;
  text-align: start;
  padding: 0 5px;
  color: #6c757d !important;
  margin-bottom: 2rem;

}
.inst-data p {
  font-size: 16px !important;
}

.inst-location {
  margin-left: 20px !important;
  font-size: 15px;
}

</style>

        </head>
        <body>
          <div class="print-container page-break">
            ${frontCardHTML}
          </div>
          <div class="print-container">
            ${backCardHTML}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `)

    printWindow.document.close()
    printWindow.focus()
  }

  const handleBack = () => {
    navigate('/TeacherList')
  }
  const handleTeacherProfile = () => {
    navigate(`/TeacherProfile/${id}`)
  }

  // Same resolution as TeacherProfile.js so images match when navigating with state: { teacher }
  const defaultTeacherPhoto = `${process.env.PUBLIC_URL || ''}/student.png`
  const teacherImageSrc = (() => {
    const img = teacher?.teacher_image
    if (
      img &&
      String(img).trim() !== '' &&
      String(img).toLowerCase() !== 'null'
    ) {
      return img
    }
    return defaultTeacherPhoto
  })()

  const teacherDesignation =
    teacher?.designation != null &&
    String(teacher.designation).trim() !== ''
      ? String(teacher.designation).trim()
      : 'Teacher'

  return (
    <>
      <style>
        {`
         @media (max-width: 767.98px) {
          .responsive-btn {
            margin-top:5px !important;
            padding: 0.25rem 0.5rem !important;
            font-size: 0.875rem !important;
          }
        }
        @media (max-width: 767.98px) {
          .card-id-container{
           margin-top: 4rem !important ;
           margin-left:auto !important;
           margin-right:auto !important;
           max-width:100% !important;
          }
          .inst-name,
          .inst-about {
            font-size: 0.8rem !important;
            text-align: center;
          }

          .student-name h6 {
            font-size: 1rem !important;
          }

          .back-card{
            display:block !important;
            margin-left:auto !important;
            margin-right:auto !important;
          }
        }

        `}
      </style>
      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: '12px',
          paddingRight: '12px',
        }}
      >
        {teacher ? (
          <>
            <div
              className="container-fluid p-0"
              style={{
                marginTop: window.innerWidth < 992 ? '55px' : '-12px',
                paddingLeft: '0px',
                paddingRight: '0px',
              }}
            >
              <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    background: '#F3F4F6',
                    paddingLeft: '28px',
                    paddingRight: '28px',
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    overflow: 'visible',
                    borderBottom: '1px solid #D1D3D4',
                    width: '100%',
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        background: '#223843',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      {!logoError ? (
                        <img
                          src={institueLogoApi}
                          alt="School Logo"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                          }}
                          onError={() => setLogoError(true)}
                        />
                      ) : (
                        <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                      )}
                    </div>

                    <h3
                      className="m-0 fw-bold"
                      style={{
                        letterSpacing: '-0.02em',
                        overflow: 'visible',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontSize: 'clamp(18px, 2.5vw, 22px)',
                        color: '#223843',
                        lineHeight: '1.2',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                    >
                      <span style={{ color: '#223843' }}>{teacher.name}</span>
                      &apos;s ID Card
                    </h3>
                  </div>

                  {!isMobile && <ProfileDropdown />}
                </div>

                <div
                  className="d-flex justify-content-center justify-content-md-end align-items-center gap-3 flex-nowrap"
                  style={{
                    paddingLeft: '28px',
                    paddingRight: '28px',
                    paddingTop: '10px',
                    width: '100%',
                  }}
                >
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                    onMouseEnter={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#223843'
                        button.style.borderColor = '#223843'
                        button.style.transform = 'scale(1.05)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1.05)'
                      }
                      e.currentTarget.style.transform = 'scale(1.02)'
                    }}
                    onMouseLeave={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#223843'
                        button.style.borderColor = '#223843'
                        button.style.transform = 'scale(1)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1)'
                      }
                      e.currentTarget.style.transform = 'scale(1)'
                    }}
                  >
                    <button
                      type="button"
                      onClick={handleTeacherProfile}
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        border: '1px solid #223843',
                        backgroundColor: '#223843',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      title="Go to Teacher Profile"
                    >
                      <BsEyeFill size={20} />
                    </button>
                    <span
                      style={{
                        fontSize: isMobile ? '13px' : '14px',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontWeight: '500',
                        transition: 'transform 0.2s ease',
                        display: 'inline-block',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Go to{' '}
                      <span className="fw-bold text-primary">{teacher.name}</span>{' '}
                      Profile
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center gap-2"
                    style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                    onMouseEnter={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#223843'
                        button.style.borderColor = '#223843'
                        button.style.transform = 'scale(1.05)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1.05)'
                      }
                      e.currentTarget.style.transform = 'scale(1.02)'
                    }}
                    onMouseLeave={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#223843'
                        button.style.borderColor = '#223843'
                        button.style.transform = 'scale(1)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1)'
                      }
                      e.currentTarget.style.transform = 'scale(1)'
                    }}
                  >
                    <button
                      type="button"
                      onClick={handleBack}
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        border: '1px solid #223843',
                        backgroundColor: '#223843',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      title="Go to Teacher List"
                    >
                      <BsArrowLeft size={20} />
                    </button>
                    <span
                      style={{
                        fontSize: isMobile ? '13px' : '14px',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontWeight: '500',
                        transition: 'transform 0.2s ease',
                        display: 'inline-block',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Go to Teacher List
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div id="print-idcard" className="printable-section">
              <Container
                className="d-flex justify-content-center align-items-center vh-75 card-id-container"
                style={{ minHeight: '65vh' }}
              >
                <Row className="justify-content-center">
                  <Col
                    xs={12}
                    md={6}
                    className="d-flex justify-content-center align-items-center mb-4"
                  >
                    <Card
                      style={{
                        width: '100%',
                        maxWidth: '360px',
                        height: '500px',
                        marginTop: '20px',
                        borderRadius: '15px',
                        overflow: 'hidden',
                      }}
                      className="p-3 shadow border border-2 text-center position-relative front-card"
                      ref={frontRef}
                    >
                      <div
                        className="py-2 institute-header"
                        style={{
                          background: '#223843',
                          color: 'white',
                          borderTopLeftRadius: '12px',
                          borderTopRightRadius: '12px',
                          fontWeight: 'bold',
                          letterSpacing: '1px',
                          WebkitPrintColorAdjust: 'exact',
                          printColorAdjust: 'exact',
                        }}
                      >
                        <h6 className="m-0 inst-name">
                           {instituteCookies?.name  || 'Institute Management'}{' '}
                        </h6>
                        <p className="m-0 text-white-50 small inst-about">
                          Education for Excellence
                        </p>
                      </div>

                      <Card.Body
                        className="p-2 position-relative"
                        style={{ zIndex: 2 }}
                      >
                        <div className="print-image-wrapper d-flex justify-content-center my-2">
                          <Image
                            className="img-style"
                            src={teacherImageSrc}
                            style={{
                              width: '90px',
                              height: '90px',
                              border: '1px solid #223843',
                              background: 'white',
                            }}
                          />
                        </div>

                        <div className="student-name fw-bold">
                          <h6 className="fw-bold">
                            {teacher?.name?.toUpperCase() || 'N/A'}
                          </h6>
                          <p className="text-muted small m-0">
                            Session : {instituteCookies?.session_name || 'N/A'}
                          </p>
                          <p
                            className="text-muted small m-0 mt-1"
                            title={teacherDesignation}
                            style={{
                              fontSize: '11px',
                              fontWeight: 600,
                              lineHeight: 1.25,
                              maxWidth: '100%',
                              paddingLeft: '4px',
                              paddingRight: '4px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {teacherDesignation}
                          </p>
                        </div>
                        <hr className="mt-2 mb-2" />

                        <Row className="text-start ps-3 student-bio fw-bold">
                          <Col
                            xs={12}
                            style={{ color: '#223843' }}
                            className="d-flex align-items-center fs-6 mt-2 bio-item"
                          >
                            <FaIdBadge className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Staff ID:</strong> {teacher?.id ?? ''}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            style={{ color: '#223843' }}
                            className="d-flex align-items-center fs-6 mt-2 bio-item"
                          >
                            <FaCalendarAlt className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Join:</strong>{' '}
                              {teacher?.joining_date
                                ? new Date(
                                    teacher.joining_date,
                                  ).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                  })
                                : null}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            style={{ color: '#223843' }}
                            className="d-flex align-items-center fs-6 mt-2 bio-item"
                          >
                            <FaEnvelope className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Email:</strong> {teacher?.email || ''}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            style={{ color: '#223843' }}
                            className="d-flex align-items-center fs-6 mt-2 bio-item"
                          >
                            <FaPhone className="me-2" />{' '}
                            <p className="m-0 small">
                              <strong>Phone:</strong> +91 {teacher?.phone || ''}
                            </p>
                          </Col>
                        </Row>

                        <hr className="mt-2 mb-4 mt-2" />
                        <div className="text-center mt-2 stamp">
                          <Image
                            src={stampUrlApi}
                            alt="stamp"
                            style={{
                              width: '90px',
                              height: '90px',
                              marginTop: '-1.15rem',
                            }}
                            roundedCircle
                            onError={(e) => {
                              e.currentTarget.onerror = null
                              e.currentTarget.src = NO_STAMP_SRC
                            }}
                          />
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col>
                    <Card
                      ref={backRef}
                      className="p-3 shadow border border-2 text-center position-relative back-card"
                      style={{
                        width: '360px',
                        height: '500px',
                        marginTop: '20px',
                        borderRadius: '15px',
                        overflow: 'hidden',
                      }}
                    >
                      <div className="inst-top-row">
                        <div className="mt-5 mb-2 inst-logo">
                          <Image
                            className="img-style"
                            src={
                              typeof institueLogoApi === 'string'
                                ? institueLogoApi.replace(/^http:\/\//i, 'https://')
                                : institueLogoApi
                            }
                            alt="Logo"
                            style={{
                              width: '150px',
                              height: '150px',
                              borderRadius: '50%',
                              objectFit: 'cover',
                            }}
                            onError={(e) => {
                              e.currentTarget.onerror = null
                              e.currentTarget.src = '/no_image.png'
                            }}
                          />
                        </div>
                        <div className="py-2 inst-info">
                          <h5 className="m-0">INSTITUTE INFORMATION</h5>
                        </div>
                      </div>

                      <Card.Body className="p-3 mt-3 ins-card">
                        <div className="inst-data">
                          <p className="small text-muted text-start fw-semibold ">
                            {instituteCookies?.name  || 'This Institute'}{' '}
                            is a premier educational institution dedicated to
                            excellence in technical education.
                          </p>
                        </div>

                        <Row className="text-start ps-3 mt-3 inst-location student-bio">
                          <Col
                            xs={12}
                            style={{ color: '#223843' }}
                            className="d-flex align-items-center fs-6 bio-item"
                          >
                            <FaMapMarkerAlt className="me-2" />{' '}
                            <p className="m-0 small">
                              {' '}
                              <span className="fw-bold">Address : </span>{' '}
                               {instituteCookies?.address  || ''}{' '}
                            </p>
                          </Col>

                          <Col
                            xs={12}
                            style={{ color: '#223843' }}
                            className="d-flex align-items-center fs-6 bio-item"
                          >
                            <FaHashtag className="me-2" />
                            <p className="m-0 small">
                              {' '}
                              <span className="fw-bold">Pincode : </span>{' '}
                              {instituteCookies?.pincode || ''}
                            </p>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>

            <div className="text-center mt-4 d-print-none">
              <Button
                variant="primary"
                onClick={handlePrint}
                className="me-2"
                style={{ backgroundColor: '#223843', borderColor: '#223843' }}
              >
                Print ID Card
              </Button>
              <Button variant="success" onClick={handleDownloadBoth}>
                Download Image
              </Button>
            </div>
          </>
        ) : (
          <p>Loading ID Card...</p>
        )}
      </div>
    </>
  )
}
